import type { Product } from 'domain/product'
import type { FC } from 'react'

import { GeneralError, NoProductError } from 'components/errors/ErrorPage'
import { useStoreId } from 'utils/hooks/store/use-store-id'

import { ProductPageTemplate } from './components/ProductPageTemplate'
import { ProductView } from './components/ProductView'

export interface ProductPageProps {
  error?: boolean
  product: Product | null
}

export const ProductPage: FC<ProductPageProps> = ({ error, product }) => {
  const { selectedStoreId } = useStoreId()

  /** Product is found in current store if we have a store selected and the product is NOT a global fallback. */
  const inCurrentStore = !!selectedStoreId && !!product && !product.isGlobalFallback

  if (error) {
    return (
      <ProductPageTemplate error>
        <GeneralError />
      </ProductPageTemplate>
    )
  }

  if (!product) {
    return (
      <ProductPageTemplate>
        <NoProductError />
      </ProductPageTemplate>
    )
  }

  return (
    <ProductPageTemplate hierarchyPath={product.hierarchyPath} product={product}>
      <ProductView inCurrentStore={inCurrentStore} product={product} />
    </ProductPageTemplate>
  )
}
